export const optType = {
    AGREE: 'AGREE',
    REJECT: 'REJECT',
};
